module.exports = __webpack_public_path__ + "static/sphere_ir_circle-6ac91af5453caa73ef1effa6f2ed5649.png";